import React from 'react';
import { useAccount } from '../contexts/AccountContext';
const columns = [{
  heading: 'Shop',
  links: [{
    label: 'Night Suits',
    href: '/#collection'
  }, {
    label: 'T-Shirts',
    href: '/#collection'
  }, {
    label: 'Gift Cards',
    href: '/#collection'
  }, {
    label: 'Size Guide',
    href: '/#collection'
  }]
}, {
  heading: 'House',
  links: [{
    label: 'Our Material',
    href: '/#materials'
  }, {
    label: 'The Atelier',
    href: '/#atelier'
  }, {
    label: 'Repairs & Care',
    href: '/#materials'
  }, {
    label: 'Stockists',
    href: '/#atelier'
  }]
}, {
  heading: 'Service',
  links: [{
    label: 'Account',
    href: '#account'
  }, {
    label: 'Shipping',
    href: '/#materials'
  }, {
    label: 'Returns',
    href: '/#materials'
  }, {
    label: 'Privacy',
    href: '/#materials'
  }]
}];
export function Footer() {
  const {
    openAccount
  } = useAccount();
  return <footer className="bg-bone" data-id="element-105" data-mp="2ez1ja9vokyyb">
      <div className="mx-auto max-w-[1400px] px-6 py-20 lg:px-12" data-id="element-106" data-mp="2evx8gtnpn4yo">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4" data-id="element-107" data-mp="3labt60db0esh">
          <div data-id="element-108" data-mp="3gaz7hiy65drh">
            <p className="font-display text-xl font-light tracking-[0.3em] text-ink" data-id="element-109" data-mp="3gbimorwfpo1t">
              TENZY&nbsp;CLUB
            </p>
            <p className="mt-4 max-w-xs text-sm font-light leading-relaxed text-smoke" data-id="element-110" data-mp="3v5n5yd55jbxl">
              Studio at 12th Main, Indira Nagar, Bangalore.
            </p>
            <p className="mt-3 max-w-xs text-sm font-light leading-relaxed text-smoke" data-id="element-111" data-mp="81ywqhwtbw3g">
              Complimentary shipping nationwide.
Fixed prices - No Sales & No Discounts.
            </p>
          </div>
          {columns.map(col => <nav key={col.heading} aria-label={col.heading} data-id="element-112" data-mp="huo533x2gtuk">
              <h3 className="eyebrow text-ink" data-id="element-113" data-mp="cv1s8vl5hfma">{col.heading}</h3>
              <ul className="mt-5 space-y-3" data-id="element-114" data-mp="qt8flhsh3x7p">
                {col.links.map(link => <li key={link.label} data-id="element-115" data-mp="ms6fyzun9j57">
                    {link.href === '#account' ? <button type="button" onClick={() => openAccount('signin')} className="text-sm font-light text-smoke transition-colors hover:text-ink" data-id="element-116" data-mp="tv4o84h2f862">
                        {link.label}
                      </button> : <a href={link.href} className="text-sm font-light text-smoke transition-colors hover:text-ink" data-id="element-117" data-mp="18ksmewty9qpk">
                        {link.label}
                      </a>}
                  </li>)}
              </ul>
            </nav>)}
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-greige/70 pt-6 text-[11px] tracking-[0.14em] text-smoke sm:flex-row sm:items-center sm:justify-between" data-id="element-118" data-mp="1rjemc8dqdbrw">
          <p data-id="element-119" data-mp="3ta8avl5p53c1">© {new Date().getFullYear()} Tenzy Club</p>
          <p className="uppercase" data-id="element-120" data-mp="3tb1bs5hz4ym9">Made in India</p>
        </div>
      </div>
    </footer>;
}